import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { Fields } from '../../Fields';
import { FIELD_TYPES, showDateTimeFromString } from '../../../utils/utils';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import PickIcon from '@mui/icons-material/RadioButtonUnchecked';
import UnPickIcon from '@mui/icons-material/RadioButtonChecked';
import DeleteIcon from '@mui/icons-material/Delete';
import JHApi from "../../../utils/JHApi"

export default function CVManager(props) {
    const isLoading = props.isLoading || false
    const journeyData = props.journeyData || {} 

    const isActiveJHUser = props.isActiveJHUser || false

    const isPublication = props.isPublication || false

    const isAdmin = props.isAdmin
    const userId = props.userId

    const isApply = props.isApply || false
    const editSection = props.editSection
    const applyPickedCVIndex = props.applyPickedCVIndex

    const defResumes = journeyData.CVLinkInCoverLetter ? [{title:'CV 1', link:journeyData.CVLinkInCoverLetter, picked:true}] : []

    const resumes = journeyData.resumes&&journeyData.resumes.length>0 ? journeyData.resumes : defResumes

    const haveCV = resumes.filter(resume=>(!resume.isDeleted)).length > 0

    const defDialogData = {open:false}

    const [dialogData, setDialogData] = useState((haveCV || !isApply) ? {open:false} : {open:true, editMode:true});
    const [convertStatus, setConvertStatus] = useState();
    const [uplaodMessage, setUplaodMessage] = useState('');
    const [noGoogleDocs, setNoGoogleDocs] = useState(false);

    const handlePickCV = (id) => {
        let fields = {}

        if (isApply){
            fields.resumes = resumes.map((resume, index) => (index === id)?{...resume, applyPicked:true}:{...resume, applyPicked:false})
        } else {
            fields = {CVLinkInCoverLetter: resumes[id].link, goToNextStep:false}
            fields.resumes = resumes.map((resume, index) => (index === id)?{...resume, picked:true}:{...resume, picked:false})
        }

        props.handleSaveData(fields,(response)=>{
            setDialogData(defDialogData)
            if (id !== undefined && (!isApply || !resumes[id].CVUrl)){
                converToDocx()
            } else {
                if (id !== undefined && props.handlaeAfterSelect){
                    props.handlaeAfterSelect()
                }
            }
        }, (error) => {
            setDialogData({...dialogData,error})
        })
    }

    const handleSave = e => {
        e.preventDefault();

        let paramsToPass = {goToNextStep:false}

        let title = dialogData.title
        if (!title){
            title = 'CV ' + (resumes.length + 1)
        }

        if (dialogData.id !== undefined){
            paramsToPass.resumes = resumes.map((resume, index) => (index === dialogData.id)?{...resume, title, link:dialogData.link, isDeleted:dialogData.isDelete}:resume)

            if(resumes[dialogData.id].picked){
                paramsToPass.CVLinkInCoverLetter = dialogData.link
            }
        } else {
            paramsToPass.resumes = [...resumes, {title, link:dialogData.link}]
        }

        props.handleSaveData(paramsToPass,(response)=>{
            setDialogData(defDialogData)
        }, (error) => {
            setDialogData({...dialogData,error})
        })
    }

    const converToDocx = () => {
        let paramsToPass = {isApply}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        props.preServerCall()
        setConvertStatus()

        JHApi.convertGoogleDocsToDocx(paramsToPass,(response)=>{
            props.postServerCall(null, response)
            setConvertStatus('Completed')
            if (props.handlaeAfterSelect){
                props.handlaeAfterSelect()
            }
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            setConvertStatus('Failed')
            props.postServerCall()

            if (isApply){
                handlePickCV()
            }
        })
    }

    const converToPdf = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        props.preServerCall()
        setConvertStatus()

        JHApi.convertGoogleDocsToPdf(paramsToPass,(response)=>{
            props.postServerCall(null, response)
            setConvertStatus('DownloadCompleted')
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            setConvertStatus('DownloadFailed')
            props.postServerCall()
        })
    }

    const uploadPublishCVFile = event => {
        const maxUploadResumeSize = 50 * 1024; // 50 KB
        const file = event.target.files[0];

        if (!file) {
            return null
        }

        if(file.size > maxUploadResumeSize){
            setUplaodMessage('File too big - 50 KB Max')
            return null
        }
        
        const extension =  file.name.split('.').pop();
        if(!extension.match(/docx|pdf/ig)){
            setUplaodMessage('Invalid extension')
            return null
        }

        props.preServerCall()
        setUplaodMessage('Uploading...')

        const data = new FormData()
        data.append('file', file, file.name)

        if (isAdmin){
            data.append('userId', userId)
        }

        if (isApply){
            data.append('isApply', isApply)
        }

        JHApi.uploadPublishCVFile(data, (response)=>{
            props.postServerCall(null, response)
            setUplaodMessage('')
        }, (error)=>{
            const errorMessage = (error && error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Something went wrong'
            setUplaodMessage('')
            props.postServerCall(errorMessage)
        });
    }

    const getValue = (name, defaultValue) => {
        if (dialogData[name] !== undefined){
            return dialogData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeField = e => {
        setDialogData({...dialogData,[e.target.name]: e.target.value})
    };

    const handleCancel = () => {
        setDialogData(defDialogData)
    }

    const handleAddLink = () => {
        setDialogData({open:true})
    }

    const handleEditLink = (id, object) => () => {
        setDialogData({open:true, id, ...object})
    }

    const handleDeleteLink = (id, object) => () => {
        setDialogData({open:true, id, isDelete:true, ...object})
    }

    const fields = [
        {name:'title', label:'CV Name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12},
        {name:'link', label:'Link', defaultValue: '', type:FIELD_TYPES.TEXT, placeholder:'Example: https://docs.google.com/document/d/{id}/edit?usp=sharing&ouid={uid}&rtpof=true&sd=true', sm:12, required:true},
    ]

    //const linkStyle = {display: 'inline-flex',border: '1px solid rgb(192 192 192)',padding: '4px 8px',fontSize: 16, minHeight:26, alignItems:'center'}
    //const linkStylePicked = {...linkStyle, backgroundColor: 'rgb(255, 242, 204)'}
    /*style={resume.picked?linkStylePicked:linkStyle}*/

    return (
        <>
            {(!isApply || (editSection==='CV')) && <>
            <Dialog onClose={handleCancel} open={dialogData.open}>
                {(!isActiveJHUser)&&<DialogTitle>Shared Google docs CV</DialogTitle>}
                <form onSubmit={handleSave}>
                    {(dialogData.error)&&<Typography color="error">{dialogData.error}</Typography>}
                    <DialogContent dividers>
                        {dialogData.isDelete?
                        <Typography>Delete CV?</Typography>:<>
                            {!isActiveJHUser&&<>
                                {(dialogData.id === undefined) && <Typography style={{marginBottom: 8}}>
                                    Later we will make a Word file from it<br/>
                                    Having both formats ensures compatibility with every employer and system, no matter what they use.
                                </Typography>}
                                {noGoogleDocs&&<Typography style={{marginTop: 8}}>
                                    <b>If you don't have Google docs CV</b><br/>
                                    1. Upload you CV file to Google drive<br/>
                                    2. Make sure it's converted to Google docs<br/>
                                    3. Share to everyone with the link
                                </Typography>}
                            </>}
                            <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                        </>}
                    </DialogContent>
                    <DialogActions>
                        {!isActiveJHUser&&<><Button style={{textTransform: 'none'}} disabled={isLoading} onClick={()=>setNoGoogleDocs(true)} color="primary" size="small" aria-label="Cancel">
                            I don't have Google docs CV
                        </Button>
                        <div style={{flex:1}}></div></>}
                        <Button disabled={isLoading} onClick={handleCancel} color="primary" size="small" aria-label="Cancel">
                            {dialogData.isDelete?'No':'Cancel'}
                        </Button>
                        <Button
                            disabled={isLoading}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label='Save'
                        >
                            {dialogData.isDelete?'Yes':'Save'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            {(journeyData.CVUrl&&!journeyData.CVLinkInCoverLetter)&&<Typography><a target='_blank' rel="noopener noreferrer" href={journeyData.CVUrl}>Uploaded CV{journeyData.CVUrlUploadTime?(' - '+showDateTimeFromString(journeyData.CVUrlUploadTime, true)):''}</a></Typography>}

            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, marginTop: 8}}>
                {(haveCV || !isApply)&&<Typography variant='h3' style={{fontSize: 18,lineHeight: '28px'}}>{isApply?'Select CV:':'Google Docs CV Files'}</Typography>}                <Button
                variant='contained'
                    disabled={isLoading}
                    onClick={handleAddLink}
                    color="primary"
                    style={{textTransform: 'capitalize', minWidth: 200, marginLeft: 16}}
                    startIcon={<AddIcon />}
                >
                    Add Google Docs CV
                </Button>
            </div>

            {(haveCV && isApply)&&<Typography>
                The file must be:
                <ul style={{paddingLeft: 22, marginTop: 8}}>
                    <li>Google Doc</li>
                    <li>Shared with everyone</li>
                </ul>
            </Typography>}

            {resumes.map((resume, index) => {
                const isSelected = isApply ? (resume.applyPicked) : resume.picked
                
                return (<Fragment key={index}>            
                    {!resume.isDeleted&&<div  className={"tag"+(isSelected?" selected":"")} style={{display: 'inline-flex', fontSize: 15, alignItems: 'center', cursor: 'default'}} >
                        <IconButton disabled={!isAdmin && !isApply} aria-label="edit" onClick={()=>{if(!isSelected||isApply){handlePickCV(index)}}} size='small' style={{marginRight:4}} color='primary'>
                            {isSelected?<UnPickIcon fontSize="small" />:<PickIcon fontSize="small" />}
                        </IconButton>
                        <a href={resume.link} target="_blank" rel="noopener noreferrer">{resume.title}</a>
                        <IconButton aria-label="edit" onClick={handleEditLink(index, resume)} size='small' style={{marginLeft:4}}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                        {(isAdmin&&!isSelected&&!resume.picked)&&<IconButton aria-label="delete" onClick={handleDeleteLink(index, resume)} size='small' style={{marginLeft:4}}>
                            <DeleteIcon/>
                        </IconButton>}
                    </div>}
                </Fragment>)
            })}
            </>}

            {/*resumes.map((resume, index) => <Fragment key={index}>            
                {!resume.isDeleted&&resume.picked&&<div className={clsx(journeyClasses.cvclTag, resume.picked&&journeyClasses.cvclTagActive)} >
                    <IconButton disabled={!isAdmin} aria-label="edit" onClick={()=>{if(!resume.picked){handlePickCV(index)}}} size='small' style={{marginRight:4}} color='primary'>
                        {resume.picked?<UnPickIcon fontSize="small" />:<PickIcon fontSize="small" />}
                    </IconButton>
                    <a href={resume.link} target="_blank" rel="noopener noreferrer" style={{fontSize: 16}}>{resume.title}</a>
                    <div style={{flex:1}}></div>
                    <IconButton aria-label="edit" onClick={handleEditLink(index, resume)} size='small' style={{marginLeft:4}}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    {(isAdmin&&!resume.picked)&&<IconButton aria-label="delete" onClick={handleDeleteLink(index, resume)} size='small' style={{marginLeft:4}}>
                        <DeleteIcon/>
                    </IconButton>}
                </div>}
            </Fragment>)}
            {resumes.map((resume, index) => <Fragment key={index}>            
                {!resume.isDeleted&&!resume.picked&&<div className={clsx(journeyClasses.cvclTag, resume.picked&&journeyClasses.cvclTagActive)} >
                    <IconButton disabled={!isAdmin} aria-label="edit" onClick={()=>{if(!resume.picked){handlePickCV(index)}}} size='small' style={{marginRight:4}} color='primary'>
                        {resume.picked?<UnPickIcon fontSize="small" />:<PickIcon fontSize="small" />}
                    </IconButton>
                    <a href={resume.link} target="_blank" rel="noopener noreferrer" style={{fontSize: 16}}>{resume.title}</a>
                    <div style={{flex:1}}></div>
                    <IconButton aria-label="edit" onClick={handleEditLink(index, resume)} size='small' style={{marginLeft:4}}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    {(isAdmin&&!resume.picked)&&<IconButton aria-label="delete" onClick={handleDeleteLink(index, resume)} size='small' style={{marginLeft:4}}>
                        <DeleteIcon/>
                    </IconButton>}
                </div>}
            </Fragment>)*/}

            {(isApply&&convertStatus==='Failed')&&<Typography>
                <Typography color='error'>There’s a problem with the file. Make sure:</Typography>
                <ul style={{paddingLeft: 22, marginTop: 8}}>
                    <li>It’s a Google Doc</li>
                    <li>It’s shared with everyone</li>
                </ul>
            </Typography>}

            {(isApply&&applyPickedCVIndex!==-1)?<>
                {/*<Typography variant='h3' style={{fontSize: 18,lineHeight: '28px', marginTop: 8}}>Attachment CV:</Typography>*/}
                {/*(convertStatus==='Completed')&&<>
                    <Typography>Convert to word format for attachment completed</Typography>
                    <Typography><strong>Is file looks good?</strong></Typography>
                    <Button onClick={()=>setConvertStatus()} size='small' color='primary' variant='contained' style={{marginRight: 8, marginBottom: 8}}>Yes</Button>
                    <Button onClick={()=>setConvertStatus('CompletedFailed')} size='small' color='primary' variant='outlined' style={{marginBottom: 8}}>No</Button>
                </>}
                {(convertStatus==='CompletedFailed')&&<Typography>
                    1. Open CV on Google docs<br/>
                    2. Select and copy all content of file (Ctrl + A, then Ctrl + C)<br/>
                    3. Open new Word file, paste the content (Ctrl + V) <br/>
                    4. Save as Word file (.docx)<br/>
                    5. Upload Word file here*
                </Typography>}
                {(convertStatus==='DownloadCompleted')&&<Typography>
                    <strong>Convert Completed</strong><br/>
                    Check the file
                </Typography>}
                {(convertStatus==='Failed')&&<Typography>
                    <strong style={{color:'#f44336'}}>Convert Failed</strong><br/>
                    - Validate that the file is Google docs<br/>
                    - Validate is shared with everyone<br/>
                    If none of this help:<br/>
                    1. Open CV on Google docs<br/>
                    2. Select and copy all content of file (Ctrl + A, then Ctrl + C)<br/>
                    3. Open new Word file, paste the content (Ctrl + V) <br/>
                    4. Save as Word file (.docx)<br/>
                    5. Upload Word file here
                </Typography>}
                {(convertStatus==='DownloadFailed')&&<Typography>
                    <strong style={{color:'#f44336'}}>Convert Failed</strong><br/>
                    - Validate that the file is correct type<br/>
                    - Validate is shared with everyone<br/>
                </Typography>*/}

                {(editSection==='attachedCV')&&<>
                    {/*(resumes[applyPickedCVIndex].CVUrl)&&<Typography><a target='_blank' rel="noopener noreferrer" href={resumes[applyPickedCVIndex].CVUrl}>CV to attach{resumes[applyPickedCVIndex].CVUrlUploadTime?(' - '+showDateTimeFromString(resumes[applyPickedCVIndex].CVUrlUploadTime, true)):''}</a></Typography>*/}
                    {/*(resumes[applyPickedCVIndex].CVUrl)&&<a target='_blank' rel="noopener noreferrer" href={resumes[applyPickedCVIndex].CVUrl} 
                        style={{color: 'initial', display: 'flex', border: '1px solid #0003', borderRadius: 8, padding: 8, width: 'fit-content', textDecoration: 'none'}}
                    >
                        <div style={{marginRight:8}}><FileWordIcon color='primary' style={{fontSize: 32}}/></div>
                        <div style={{marginRight: 8}}>
                            <Typography color='textPrimary'>CV to attach</Typography>
                            {resumes[applyPickedCVIndex].CVUrlUploadTime&&<Typography color='textSecondary'>{showDateTimeFromString(resumes[applyPickedCVIndex].CVUrlUploadTime, true)}</Typography>}
                        </div>
                    </a>*/}

                    <Typography>{uplaodMessage}</Typography>
                    <input
                        accept=".docx"
                        id="contained-button-file"
                        type="file"
                        style={{display:"none"}}
                        onChange={uploadPublishCVFile}
                    />
                    <label htmlFor="contained-button-file">
                        <Button 
                            disabled={isLoading} 
                            variant="outlined" 
                            color="primary" 
                            component="span" 
                            aria-label="Upload" 
                            size="small" 
                            style={{margin:'16px 8px 0 0'}}
                        >
                            Upload New File
                        </Button>
                    </label>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={converToDocx}
                        aria-label="Convert From Google Docs"
                        disabled={isLoading}
                        style={{margin:'16px 8px 0px 0px'}}
                    >
                        Convert From Google Docs
                    </Button>
                </>}
            </>:<>
            {(isAdmin && journeyData.CVLinkInCoverLetter && isPublication)&&<div>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={converToDocx}
                    aria-label="Convert"
                    disabled={isLoading || !journeyData.CVLinkInCoverLetter}
                    style={{margin:'16px 8px 16px 0'}}
                >
                    Convert To Word
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={converToPdf}
                    aria-label="Convert"
                    disabled={isLoading || !journeyData.CVLinkInCoverLetter}
                    style={{margin:'16px 8px 16px 0'}}
                >
                    Convert To Pdf
                </Button>

                {(convertStatus==='Completed')&&<Typography>
                    <strong>Convert Completed</strong><br/>
                    Check the file, if incorect:<br/>
                    1. Open CV on Google docs<br/>
                    2. Select and copy all content of file (Ctrl + A, then Ctrl + C)<br/>
                    3. Open new Word file, paste the content (Ctrl + V) <br/>
                    4. Save as Word file (.docx)<br/>
                    5. Upload Word file here
                </Typography>}
                {(convertStatus==='DownloadCompleted')&&<Typography>
                    <strong>Convert Completed</strong><br/>
                    Check the file
                </Typography>}
                {(convertStatus==='Failed')&&<Typography>
                    <strong style={{color:'#f44336'}}>Convert Failed</strong><br/>
                    - Validate that the file is Google docs<br/>
                    - Validate is shared with everyone<br/>
                    If none of this help:<br/>
                    1. Open CV on Google docs<br/>
                    2. Select and copy all content of file (Ctrl + A, then Ctrl + C)<br/>
                    3. Open new Word file, paste the content (Ctrl + V) <br/>
                    4. Save as Word file (.docx)<br/>
                    5. Upload Word file here
                </Typography>}
                {(convertStatus==='DownloadFailed')&&<Typography>
                    <strong style={{color:'#f44336'}}>Convert Failed</strong><br/>
                    - Validate that the file is correct type<br/>
                    - Validate is shared with everyone<br/>
                </Typography>}
            </div>}
            {(isPublication&&journeyData.CVUrl)&&<Typography><a target='_blank' rel="noopener noreferrer" href={journeyData.CVUrl}>Uploaded CV{journeyData.CVUrlUploadTime?(' - '+showDateTimeFromString(journeyData.CVUrlUploadTime, true)):''}</a></Typography>}
            {(isPublication&&(isAdmin || !journeyData.CVLinkInCoverLetter)) &&<><Typography>{uplaodMessage}</Typography>
                <input
                    accept=".docx,.pdf"
                    id="contained-button-file"
                    type="file"
                    style={{display:"none"}}
                    onChange={uploadPublishCVFile}
                />
                <label htmlFor="contained-button-file">
                    <Button 
                        disabled={isLoading} 
                        variant="outlined" 
                        color="primary" 
                        component="span" 
                        aria-label="Upload" 
                        size="small" 
                        style={{margin:'16px 8px 0 0'}}
                    >
                        Upload New File
                    </Button>
                </label>
            </>}
            </>}
        </>
    )
}